module.exports = __webpack_public_path__ + "img/r-logo-blue.b946ada3.png";